import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { Nav, NavItem, Button } from 'reactstrap';

import { getContentBlockItemsByName } from '../../../Cms/CmsActions';

const PanelCallToActionMenu = ({ panel, isScrolling }) => {
    const links = getContentBlockItemsByName(panel.blocks, 'links');
    if(links && links.length) {
        return (
            <div className="d-none d-lg-inline-flex call-to-actions">
                <Nav>
                    {links.map((link, index) => (
                        <NavItem key={index}>
                            <Button color={(index + 1) === links.length ? 'warning' : 'secondary'} size={isScrolling ? 'sm' : ''} tag={Link} to={link.path}>{link.text}</Button>
                        </NavItem>
                    ))}
                </Nav>
            </div>
        );
    }
    return null;
};

PanelCallToActionMenu.defaultProps = {
    isScrolling: false,
};

PanelCallToActionMenu.propTypes = {
    panel: PropTypes.object.isRequired,
    isScrolling: PropTypes.bool,
};

export default PanelCallToActionMenu;

export const PanelCallToActionMenuModel = {
    type: 'panel',
    name: 'ctaMenu',
    blocks: [{
        name: 'links',
        type: 'link',
        max: 2,
    }],
};
